import { render, staticRenderFns } from "./AdvantagesCompanyEdit.vue?vue&type=template&id=303ccc80&scoped=true&lang=pug&"
import script from "./AdvantagesCompanyEdit.vue?vue&type=script&lang=js&"
export * from "./AdvantagesCompanyEdit.vue?vue&type=script&lang=js&"
import style0 from "./AdvantagesCompanyEdit.vue?vue&type=style&index=0&id=303ccc80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303ccc80",
  null
  
)

export default component.exports